/* eslint-disable no-unused-vars */
import Swiper from 'swiper/js/swiper';
import '~/sass/pages/spec.scss';

const { $ } = window;

let swiperPurchase = null;

function initSwiperPurchase() {
  swiperPurchase = new Swiper('#car-purchase .swiper-news', {
    slidesPerView: 1.25,
    centeredSlides: true,
    navigation: {
      nextEl: '#car-purchase .swiper-button-next',
      prevEl: '#car-purchase .swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        centeredSlides: false,
      },
      1140: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        centeredSlides: false,
      },
    },
  });
}

$(document).ready(() => {
  initSwiperPurchase();
});
